import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('thesis_token'));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await axios.get(`${API}/auth/me`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          withCredentials: true,
        });
        setUser(res.data);
      } catch (e) {
        localStorage.removeItem('thesis_token');
        setToken(null);
      } finally { setLoading(false); }
    };
    verify();
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    localStorage.setItem('thesis_token', res.data.access_token);
    setToken(res.data.access_token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    axios.post(`${API}/auth/logout`, {}, { withCredentials: true }).catch(() => {});
    localStorage.removeItem('thesis_token');
    setToken(null);
    setUser(null);
  };

  const apiCall = (method, path, body) => {
    return axios({
      method, url: `${API}${path}`, data: body,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      withCredentials: true,
    });
  };

  return (
    <AuthCtx.Provider value={{ token, user, loading, login, logout, apiCall, API }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
